﻿﻿export interface IProductCenterContactRequest {
    centerId: number;
    productId: number;
    contactId: number;
    notes: string;
}
